import { Col, Container, Row } from "react-bootstrap";
import image from "../../../images/bakhtiar.png";
import info from "../../../images/info.svg"
import "./AboutMe.css";

const AboutMe = () => {
   return (
      <div
         className="d-flex justify-content-center align-items-center  bg-dark "
         style={{ paddingTop: "150px", paddingBottom: "150px" }}
      >
         <Container>
            <Row>
               <Col xs={12} md={5} className="text-white ">
                  <div
                     data-aos="fade-up"
                     data-aos-easing="ease-in-sine"
                     data-aos-duration="1000"
                     data-aos-once="true"
                  >
                     <img
                        className="img-fluid rounded-3"
                        style={{
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center",
                           paddingTop: "50px",
                        }}
                        src={info}
                        alt=""
                     />
                  </div>
               </Col>
               <Col xs={12} md={7}>
                  <div
                     data-aos="fade-up"
                     data-aos-easing="ease-in-sine"
                     data-aos-duration="1000"
                     data-aos-once="true"
                  >
                     <h1 className=" text-white " style={{ textAlign: "left" }}>
                        About Me
                     </h1>
                     <p className="borderr"></p>
                     <p style={{ textAlign: "justify", color: "#C0C0C0" }}>
                        As a MERN Stack Developer I'm woring with React.js,
                        Node.js, Express.js and MongoDB as well as developing
                        static responsive websites using HTML5, CSS3, and
                        JavaScript (ES6). I emphasize hard effort and
                        effectiveness. As a result, I am always eager to work
                        diligently to complete any assignment. I am constantly
                        interested in mastering new technologies. My ambition is
                        to advance to the next level of Professional Web
                        Developer.
                     </p>
                     <div>
                        <p style={{ color: "#C0C0C0", textAlign: "left" }}>
                           {" "}
                           <u>
                              Some technologies I've been working with recently:
                           </u>{" "}
                        </p>
                        <div style={{ textAlign: "left" }}>
                           <h3 className="text-primary">Frontend</h3>
                           <i className="far fa-dot-circle text-primary "></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>
                              JavaScript (ES6)
                           </span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>React.js</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>
                              React Router
                           </span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>HTML5</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>CSS3</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>Bootstrap5</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>Material UI</span>
                           <h3 className="text-primary pt-3">Backend</h3>
                           <i className="far fa-dot-circle text-primary "></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>Node.js</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>Express.js</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>MongoDB</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>REST API</span>
                           <h3 className="text-primary pt-3">Tools</h3>
                           <i className="far fa-dot-circle text-primary "></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>VS Code</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>Git</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>
                              Chrome Dev Tool
                           </span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>Npm & Yarn</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>Firebase</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>Netlify</span>
                           <i class="far fa-dot-circle text-primary ps-2"></i>{" "}
                           <span style={{ color: "#C0C0C0" }}>Heroku</span>
                        </div>
                     </div>
                     <div className="py-4  " style={{ textAlign: "left" }}>
                        <span className="fav-style">
                           <a
                              href="https://github.com/bakhtiarabid"
                              target="_blank"
                           >
                              <i
                                 style={{ color: "#C0C0C0" }}
                                 class="fab fa-github p-2 rounded-3 fs-5"
                              ></i>
                           </a>
                        </span>
                        <span className="fav-style">
                           <a
                              href="https://www.linkedin.com/in/bakhtiar-abid-3a902215b/"
                              target="_blank"
                           >
                              <i
                                 style={{ color: "#C0C0C0" }}
                                 class="fab fa-linkedin-in p-2 rounded-3 fs-5 ms-2"
                              ></i>
                           </a>
                        </span>
                        <span className="fav-style">
                           <a href="https://twitter.com/abidwx" target="_blank">
                              <i
                                 style={{ color: "#C0C0C0" }}
                                 class="fab fa-twitter p-2 rounded-3 fs-5 ms-2"
                              ></i>
                           </a>
                        </span>
                        <span className="fav-style">
                           <a
                              href="https://www.facebook.com/babid2/"
                              target="_blank"
                           >
                              <i
                                 style={{ color: "#C0C0C0" }}
                                 class="fab fa-facebook p-2 rounded-3 fs-5 ms-2"
                              ></i>
                           </a>
                        </span>
                        <span className="fav-style">
                           <a
                              href="https://mail.google.com/mail/u/0/?fs=1&to=bakhtiar.abid2@gmail.com&tf=cm"
                              target="_blank"
                           >
                              <i
                                 style={{ color: "#C0C0C0" }}
                                 class="fab far fa-envelope p-2 rounded-3 fs-5 ms-2"
                              ></i>
                           </a>
                        </span>
                     </div>
                  </div>
               </Col>
            </Row>
         </Container>
      </div>
   );
};

export default AboutMe;
